import { IMappedGeoMappingItem } from 'partner360/components/filters'
import { IPartnerWithFlagRequests } from 'partner360/models/partnerFlagRequests/IPartnerWithFlagRequests'

export const buildGeoOptionsFromPartners = (
  partners: IPartnerWithFlagRequests[]
): IMappedGeoMappingItem[] => {
  const markets = new Map<string, { order: number; countries: Map<string, string> }>()

  partners.forEach((partner) => {
    if (!partner.GeoMarket || !partner.CountryCode) {
      return
    }

    const market = markets.get(partner.GeoMarket) ?? {
      order: partner.GeoMarketOrder ?? 0,
      countries: new Map<string, string>(),
    }

    market.countries.set(partner.CountryCode, partner.Country || partner.CountryCode)
    markets.set(partner.GeoMarket, market)
  })

  const options: IMappedGeoMappingItem[] = []

  Array.from(markets.entries())
    .sort(([, a], [, b]) => a.order - b.order)
    .forEach(([geoMarket, { order, countries }]) => {
      options.push({
        itemId: geoMarket,
        parentId: null,
        name: geoMarket,
        shortName: geoMarket,
        countries: Array.from(countries.keys()),
        order,
        geoMarket,
      })

      countries.forEach((countryName, countryCode) => {
        options.push({
          itemId: countryCode,
          parentId: geoMarket,
          name: countryName,
          shortName: countryName,
          countries: [countryCode],
          order: 0,
          geoMarket,
        })
      })
    })

  return options
}
